import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<typeof categories[0] | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (cat: typeof categories[0]) => {
    setSelectedCategory(cat);
    setIsOpen(false);
    window.open(cat.url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-lg md:text-xl font-semibold text-foreground-950 mb-2">
            Wybierz kategorię produktów
          </h2>
          <p className="text-sm text-foreground-600">
            Kliknij poniżej, aby przejść do wybranej kategorii w arkuszu Kakobuy
          </p>
        </div>

        <div className="relative max-w-md mx-auto" ref={dropdownRef}>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-full flex items-center justify-between gap-3 px-5 py-3.5 bg-background-50 border border-background-200 rounded-xl text-foreground-950 text-sm font-medium hover:border-primary-300 transition-all duration-200 cursor-pointer"
          >
            <div className="flex items-center gap-3">
              {selectedCategory ? (
                <>
                  <div className="w-9 h-9 flex items-center justify-center bg-primary-100 rounded-lg">
                    <i className={`${selectedCategory.icon} text-primary-500 text-base`}></i>
                  </div>
                  <span>{selectedCategory.namePl}</span>
                </>
              ) : (
                <>
                  <div className="w-9 h-9 flex items-center justify-center bg-secondary-100 rounded-lg">
                    <i className="ri-grid-line text-secondary-500 text-base"></i>
                  </div>
                  <span className="text-foreground-500">Kliknij, aby wybrać kategorię...</span>
                </>
              )}
            </div>
            <i className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}></i>
          </button>

          {isOpen && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200 rounded-xl shadow-sm z-30 max-h-80 overflow-y-auto">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => handleSelect(cat)}
                  className="w-full flex items-center gap-3 px-5 py-3 text-left text-sm text-foreground-950 hover:bg-background-100 transition-colors duration-150 cursor-pointer first:rounded-t-xl last:rounded-b-xl"
                >
                  <div className="w-9 h-9 flex items-center justify-center bg-secondary-100 rounded-lg flex-shrink-0">
                    <i className={`${cat.icon} text-secondary-500 text-base`}></i>
                  </div>
                  <span className="whitespace-nowrap">{cat.namePl}</span>
                  <span className="ml-auto text-xs text-foreground-500">{cat.name}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}